import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-project-permission',
  templateUrl: './user-project-permission.component.html',
  styleUrls: ['./user-project-permission.component.scss']
})
export class UserProjectPermissionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
